export const USERS_REVIEWS = [
  {
    name: 'Mansfield Acuff',
    review:
      'Dialogue is an amazing app. The character begins in a blank learning period, but after only three days, I believe I was speaking with a genuine person. It is fantastic!!!',
  },
  {
    name: 'Teresa Emory',
    review:
      'The best app ever, hands down! Ideal for overcoming loneliness and meeting new people, even if they are virtual. Five stars for sure!',
  },
  {
    name: 'Jindal Ambika',
    review:
      'When role play talking I feel free to be myself without having to use a filter every time I say a filthy joke or make a flirtatious comment.',
  },
];
